import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { map, Observable, of } from "rxjs";
import { IngredientDTO, IngredientsFilters } from "../../models/ingredient";
import { ListResultDTO } from "../../../helpers/listResult.interface copy";

@Injectable({
  providedIn: "root"
})
export class LaravelIngredientService {
  constructor(private httpClient: HttpClient) {}

  private get ROUTES() {
    return {
      list: environment.baseUrl + "/api/ingredients",
      show: environment.baseUrl + '/api/ingredients',
      store: environment.baseUrl + "/api/ingredients",
      delete: environment.baseUrl + "/api/ingredients",
      destroy: environment.baseUrl + '/api/ingredients'
    };
  }

  public list(
    page: number,
    per_page: number,
    order: string,
    direction: string,
    filters: IngredientsFilters,
    includes?: string[]
  ): Observable<ListResultDTO<IngredientDTO>>{
    let params = {};
        if (order) params['order'] = '' + order;
        if (direction) params['direction'] = '' + direction;
        if (includes) params['includes[]'] = includes;
        if (filters) {
          if (filters.search) params['search'] = filters.search;
        }
        if (per_page) {
          params['per_page'] = '' + per_page;
          if (page) params['page'] = '' + page;
          return this.httpClient.get<ListResultDTO<IngredientDTO>>(
            this.ROUTES.list,
            {
              params: new HttpParams({ fromObject: params }),
            }
          );
        } else {
          return this.httpClient
            .get<IngredientDTO[]>(this.ROUTES.list, {
              params: new HttpParams({ fromObject: params }),
            })
            .pipe(
              map((results) => {
                return {
                  data: results,
                  total: results.length,
                };
              })
            );
        }
  }


  public show(id: number): Observable<IngredientDTO> {
    let params = { id: '' + id };
    return this.httpClient.get<IngredientDTO>(this.ROUTES.show, {
      params: new HttpParams({
        fromObject: params,
      }),
    });
  }


  public create(name: string, additionPrice: number, minusPrice: number, description: string, type: string) {
    let ingredient = {
      name: name,
      addition_price: additionPrice,
      minus_price: minusPrice,
      description: description,
      // type: type
    };
    return this.httpClient.post(this.ROUTES.store, { ...ingredient });
  }

  public update(id: number, name: string, additionPrice: number, minusPrice: number, description: string, type: string) {
    let ingredient = {
      id: id,
      name: name,
      addition_price: additionPrice,
      minus_price: minusPrice,
      description: description,
      type: type
    };
    return this.httpClient.put(this.ROUTES.store + "/" + id, { ...ingredient });
  }

  public upsert(ingredient: IngredientDTO): Observable<IngredientDTO> {
    if (ingredient.id) {
      return this.httpClient.put<IngredientDTO>(`${this.ROUTES.store}/${ingredient.id}`, {
        ...ingredient,
      });
    } else {
      return this.httpClient.post<IngredientDTO>(`${this.ROUTES.store}`, {
        ...ingredient,
      });
    }
  }


  public delete(id: number): Observable<any> {
    return this.httpClient.delete(this.ROUTES.destroy + "/" + id);
  }
}
